"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS = exports.BannerType = exports.PunchType = void 0;
var PunchType;
(function (PunchType) {
    PunchType["In"] = "In";
    PunchType["Out"] = "Out";
})(PunchType = exports.PunchType || (exports.PunchType = {}));
var BannerType;
(function (BannerType) {
    BannerType[BannerType["EditIneligible"] = 0] = "EditIneligible";
    BannerType[BannerType["DeleteIneligible"] = 1] = "DeleteIneligible";
    BannerType[BannerType["ApproachingLimit"] = 2] = "ApproachingLimit";
    BannerType[BannerType["Blocked"] = 3] = "Blocked";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
var PUNCHWF_SELECTPUNCH_DATA_TEST_IDS;
(function (PUNCHWF_SELECTPUNCH_DATA_TEST_IDS) {
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["SELECT_PUNCH"] = "PWF-SelectPunch";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["SECTION_INELIGIBLE"] = "PWF-SelectPunch-Ineligible";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["SECTION_ELIGIBLE"] = "PWF-SelectPunch-Eligible";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["PUNCH_RADIO_BOX_INELIGIBLE"] = "PWF-SelectPunch-RadioBox-Ineligible";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["PUNCH_RADIO_BOX_ELIGIBLE"] = "PWF-SelectPunch-RadioBox-Eligible";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["PUNCH_RADIO_UNCHECKED"] = "PWF-SelectPunch-RadioBox-Unchecked";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["PUNCH_RADIO_CHECKED"] = "PWF-SelectPunch-RadioBox-Checked";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["BANNER_EDIT_INELIGIBLE"] = "PWF-SelectPunch-Banner-EditIneligible";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["BANNER_DELETE_INELIGIBLE"] = "PWF-SelectPunch-Banner-DeleteIneligible";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["BANNER_APPROACHING_LIMIT"] = "PWF-SelectPunch-Banner-ApproachingLimit";
    PUNCHWF_SELECTPUNCH_DATA_TEST_IDS["BANNER_BLOCKED"] = "PWF-SelectPunch-Banner-Blocked";
})(PUNCHWF_SELECTPUNCH_DATA_TEST_IDS = exports.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS || (exports.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS = {}));
